import React from "react";
import { Logo } from "../../constant/Index";
import "../../assets/Css/forgot.css";
import { Link } from "react-router-dom";

const ForgotPassword = () => {
	return (
		<>
			{/* <!-- Sign In Page Start Here --> */}
			<section className="signinSec ForgotPassword  p-0 ">
				<div className="container-fluid">
					<div className="row align-items-center">
						<div className="col-lg-4"></div>
						<div className="col-lg-4 p-0">
							<div className="logo-wrapper">
							<Link to="/">	<figure>
									<img src={Logo} alt="" />
								</figure></Link>
							</div>
							<div className="signInBox">
								<div className="title">
									<h1>Forgot Password</h1>
								</div>

								<div className="taglines pb-3">
									<h3>Enter Your email to recover your account</h3>
								</div>
								<form action="/CreateNewPassword">
									<div className="form-group">
										<input
											type="email"
											className="form-control"
											placeholder="Enter Your Email"
										/>
									</div>
									<div className="col-md-12 px-0 text-right mt-3">
										<button
										   onClick={(e) => {
											e.preventDefault();
											window.location.href = "/CreateNewPassword";
										  }}
											className="btn btn-secondary btnn signup-btn rounded-pill full"
											type="button"
										>
											Submit
										</button>
									</div>
									<div className="privacyDv">
										<p>Copyrights © 2022 EVX. All rights reserved.</p>
									</div>
								</form>
							</div>
						</div>
						<div className="col-lg-4"></div>
					</div>
				</div>
			</section>
			{/* <!-- Sign In Page End Here --> */}
		</>
	);
};

export default ForgotPassword;
